import AgentCommissionStatementModulesPanel from '@front/Panels/AgentCommissionStatementModulesPanel';
import * as React from 'react';
import type { User } from '../../MedicareProAPI/Entities/User/User';
import AgentCommissionStatementMappingsPanel from '../Panels/AgentCommissionStatementMappingsPanel';
import AgentCommissionStatementProcessLogPanel from '../Panels/AgentCommissionStatementProcessLogPanel';
import AgentCommissionStatementsPanel from '../Panels/AgentCommissionStatementsPanel';

enum SECTION_TAB {
  Statements = 'statements',
  Mappings = 'mappings',
  ProcessLog = 'process-log',
  Modules = 'modules',
}

type SectionTab = {
  id: SECTION_TAB;
  label: string;
  successClass: string;
  icon: string;
};

export interface AgenctCommissionStatementsProps {
  user: User;
}

export default function AgenctCommissionStatementsPage(
  props: AgenctCommissionStatementsProps
): React.JSX.Element {
  const [currentTab, setCurrentTab] = React.useState<SECTION_TAB>(SECTION_TAB.Statements);

  const sections: SectionTab[] = [
    {
      id: SECTION_TAB.Statements,
      label: 'Statements',
      successClass: 'btn-primary',
      icon: 'fa-solid fa-list',
    },
    {
      id: SECTION_TAB.Mappings,
      label: 'Mappings',
      successClass: 'btn-primary',
      icon: 'fa-network-wired',
    },
    {
      id: SECTION_TAB.ProcessLog,
      label: 'Process Log',
      successClass: 'btn-primary',
      icon: 'fa-tasks',
    },
    {
      id: SECTION_TAB.Modules,
      label: 'Modules',
      successClass: 'btn-primary',
      icon: 'fa-cogs',
    },
  ];

  return (
    <div className="row mb-3">
      <div className="col-12 mb-2">
        {sections.map((tab) => {
          const buttonClassList = ['btn', 'btn-sm', 'mr-2'];

          if (currentTab === tab.id) {
            buttonClassList.push(tab.successClass);
          } else {
            buttonClassList.push('border-secondary');
          }

          const iconClassList = ['far', tab.icon];

          return (
            <span
              onClick={(e) => {
                setCurrentTab(tab.id);
              }}
              key={tab.id}
              className={buttonClassList.join(' ')}
            >
              <i className={iconClassList.join(' ')}></i> {tab.label}
            </span>
          );
        })}
      </div>
      <div className="col-12 mb-2">
        {currentTab === SECTION_TAB.Statements && (
          <AgentCommissionStatementsPanel user={props.user} />
        )}
        {currentTab === SECTION_TAB.Mappings && (
          <AgentCommissionStatementMappingsPanel user={props.user} />
        )}
        {currentTab === SECTION_TAB.ProcessLog && (
          <AgentCommissionStatementProcessLogPanel user={props.user} />
        )}
        {currentTab === SECTION_TAB.Modules && (
          <AgentCommissionStatementModulesPanel user={props.user} />
        )}
      </div>
    </div>
  );
}
